import React from 'react';
import { number, func, bool, string } from 'prop-types';

import styles from './styles.module.scss';

function TipPercentageButton({ percentage, handleSelect, totalTip, isSelected }) {
  const handleClick = () => {
    handleSelect();
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`${isSelected && styles.selected} ${styles.percentageButton}`}>
      <div className={`column ${styles.percentageContainer}`}>
        {percentage && <span className={styles.percentageTitle}>{`${percentage}%`}</span>}
        <span className={percentage ? styles.percentagePriceLabel : styles.percentageOnly}>{totalTip}</span>
      </div>
    </button>
  );
}

TipPercentageButton.propTypes = {
  totalTip: string.isRequired,
  handleSelect: func,
  isSelected: bool,
  percentage: number
};

export default TipPercentageButton;
